<template>
  <div
    class="input"
    :class="{
      'input--error': error,
      'input--search': search,
      'dark-mode-input': darkModeClass,
    }"
    @click.stop.prevent
  >
    <slot />
    <input
      @input="onInput($event.target.value)"
      ref="input"
      :id="id"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :maxlength="maxlength"
      @keyup.enter="onEnter($event.target.value)"
      :disabled="disabled"
      @blur="blur"
    />
    <slot name="trailing" />
  </div>
</template>
<script>
export default {
  name: "Input",
  props: {
    placeholder: String,
    type: String,
    id: String,
    value: String,
    darkModeClass: Boolean,
    error: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      default: null,
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
    onEnter(e) {
      this.$emit("enter", e);
    },
    click() {
      this.$refs.input.$el.click();
    },
    blur(e) {
      this.$emit("blur", e);
    },
  },
};
</script>
<style>
@import "index.module.css";
</style>
